import { useEffect, useRef } from "react";
import { useRouter } from "./useRouter.js";
export function useRouterEvents(handler) {
    const subscribe = useRouter((r) => r.subscribe);
    const ref = useRef(handler);
    ref.current = handler;
    useEffect(() => subscribe((e) => {
        ref.current(e);
    }), []);
}
